import { classNames } from 'helpers';
import type { PropsWithChildren } from 'react';
import { useLocation } from 'react-router';

type ContainerProps = Readonly<
	PropsWithChildren & {
		className?: string;
	}
>;

export function Container(props: ContainerProps) {
	const isAdmin = useLocation().pathname.startsWith('/admin');
	const cn = classNames({ 'container-fluid': isAdmin, container: !isAdmin }, props.className);
	return <div className={cn}>{props.children}</div>;
}
